import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Vas from '../Vas';
import $ from 'jquery';
import "../css/PopUp.css";

import { ExtendedButton,SelectField } from 'component-lib';
import { RequestAjaxClass, ContractsModel } from 'models-lib';

class ContractEditState extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Title = Vas.Resources.Labels["DeclineContract"];
        this.ContractId = props.match.params.ContractId;
        this.CustomerId = props.match.params.CustomerId;
        this.CustomerName = props.match.params.CustomerName;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.ContractsModel = new ContractsModel([this]);
    }

    componentDidMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.ContractsModel.SetRequest(this.Request);

        this.ContractsModel.GetRejectionReasons();
    }

    Update(observer){
      let me =this;
      this.setState({},()=>{
        if(observer === "GetRejectionReasons"){
          let reasons = [];
          let result = this.ContractsModel.RejectionReasons;
          for (let i = 0; i < result.length; i++) {
              let reason = {};
              reason.Key = result[i].Id;
              reason.Display = result[i].Description;
              reasons.push(reason);
          }
          if (me.refs.Reasons){
              me.refs.Reasons.setState({ Data: reasons });
          }
        }
        else if(observer === "ContractsChange"){
          Vas.GetView('ContractEditStateSuccess', {CustomerId : this.CustomerId, ContractId: this.ContractId, CustomerName : this.CustomerName}, true);
        }
      });
    }
    Reject()
    {
        $("#LoadingIconPopUp").removeClass().addClass('loaderSmall');
        let rejectReason = $("#Reject").val();
        this.ContractsModel.ContractsChangeStatus(this.ContractId,rejectReason,false,true);
    }

    Close()
    {
      if(this.CustomerId !== undefined){
        Vas.GetView("ContractCardContractData",{ Id:this.ContractId, CustomerId: this.CustomerId, CustomerName: this.CustomerName },true);
      } else {
        if(localStorage.getItem('vas_role') !== '1'){
          Vas.GetView("Contracts",{All:true},true);
        }else{
          Vas.GetView("Contracts",{All:false},true);
        }
      }
    }

    render()
    {
        return (
          <div className={"form"} >
            <table>
              <thead>
                <tr>
                  <th colSpan={2}>{Vas.Resources.Labels["DeclineContract"]}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={2}><SelectField 
                    AppURL={Vas.ApplicationUrl} 
                    ref={"Reasons"} 
                    Id={"Reject"} 
                    Width={320} 
                    Label={Vas.Resources.Labels["DeclineContractReason"]} 
                    //Float={'left'} 
                    OnBlur={()=>{ this.setState({ Reject: $("#Reject").val() });}} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <ExtendedButton 
                      Usable={true} 
                      Text={Vas.Resources.Labels["Decline"]} 
                      style={{ marginTop: '2px !important' }} 
                      Float={'right'} 
                      OnClick={()=>{ this.Reject(); }} />
                  </td>
                  <td>
                    <ExtendedButton 
                      Usable={true} 
                      Text={Vas.Resources.Labels["Cancel"]} 
                      style={{ marginTop: '2px !important' }} 
                      Float={'right'} 
                      OnClick={()=>{ this.Close(); }} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default ContractEditState;
